import client from 'data/client';
import { ReportHistory } from 'data/types/report';
import { normalizeReportHistory } from 'model/report';

export type Variables = {
  pageParam?: string;
  pageSize?: number;
};

const getReportHistory = async ({ pageParam, pageSize }: Variables) => {
  const params = new URLSearchParams();

  if (pageParam) {
    params.append('cursor', pageParam);
  }
  if (pageSize) {
    params.append('pageSize', `${pageSize}`);
  }

  const response = await client.get<ReportHistory>(
    `pdf-reports/?${params.toString()}`,
  );

  return normalizeReportHistory(response.data);
};

export default getReportHistory;
